// Used for formatting text in various ways
export function getNumberWithOrdinalSuffix(num: number): string {
    const pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

    const suffixes = new Map([
        ['one', 'st'],
        ['two', 'nd'],
        ['few', 'rd'],
        ['other', 'th'],
    ]);

    const formatOrdinals = (n: number) => {
    const rule = pr.select(n);
    const suffix = suffixes.get(rule);
        return `${n}${suffix}`;
    };
    return formatOrdinals(num);
}
